module.exports = __webpack_public_path__ + "img/face1.25ac39a1.png";